(function () {
  'use strict';

  function clampIndex(index, length) {
    if (!length) return 0;
    return ((index % length) + length) % length;
  }

  function cardStep(viewport) {
    var card = viewport.querySelector('[data-ecb-card]');
    var track = viewport.querySelector('[data-ecb-card-track]');
    if (!card || !track) return viewport.clientWidth;
    var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function snapCards(viewport) {
    if (window.innerWidth > 1024) return;
    var step = cardStep(viewport);
    if (!step) return;
    var target = Math.round(viewport.scrollLeft / step) * step;
    viewport.scrollTo({ left: target, behavior: 'smooth' });
  }

  function bindCardViewport(viewport) {
    if (!viewport || viewport.dataset.ecbCardsBound === 'true') return;
    viewport.dataset.ecbCardsBound = 'true';

    var dragging = false;
    var pointerId = null;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    viewport.addEventListener('pointerdown', function (event) {
      if (window.innerWidth > 1024 || event.button > 0) return;
      dragging = true;
      moved = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      try { viewport.setPointerCapture(pointerId); } catch (_error) {}
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!dragging || event.pointerId !== pointerId) return;
      var distance = event.clientX - startX;
      if (Math.abs(distance) > 4) moved = true;
      viewport.scrollLeft = startScroll - distance;
      if (moved) event.preventDefault();
    });

    function endDrag(event) {
      if (!dragging || (event && event.pointerId !== pointerId)) return;
      dragging = false;
      try { viewport.releasePointerCapture(pointerId); } catch (_error) {}
      pointerId = null;
      viewport.classList.remove('is-dragging');
      snapCards(viewport);
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('lostpointercapture', endDrag);

    viewport.addEventListener('keydown', function (event) {
      if (window.innerWidth > 1024 || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
      event.preventDefault();
      var direction = event.key === 'ArrowRight' ? 1 : -1;
      viewport.scrollBy({ left: direction * cardStep(viewport), behavior: 'smooth' });
    });
  }

  function init(root) {
    if (!root || root.dataset.ecbBound === 'true') return;
    root.dataset.ecbBound = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ecb-slide]'));
    var swirl = root.querySelector('[data-ecb-swirl]');
    var previous = root.querySelector('[data-ecb-prev]');
    var next = root.querySelector('[data-ecb-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ecb-dot]'));
    var index = clampIndex(parseInt(root.dataset.initialSlide || '0', 10), slides.length);

    root.querySelectorAll('[data-ecb-card-viewport]').forEach(bindCardViewport);

    function activate(nextIndex) {
      if (!slides.length) return;
      index = clampIndex(nextIndex, slides.length);

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
        if (active) {
          var viewport = slide.querySelector('[data-ecb-card-viewport]');
          if (viewport) viewport.scrollLeft = 0;
        }
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      var activeSlide = slides[index];
      var foreground = activeSlide.dataset.ecbForeground || '#408024';
      var background = activeSlide.dataset.ecbBackground || '#2b4212';
      root.style.backgroundColor = background;
      if (swirl) {
        swirl.style.background = 'radial-gradient(circle at 30% 30%, ' + foreground + ' 0%, ' + background + ' 72%)';
      }
    }

    if (previous) previous.addEventListener('click', function () { activate(index - 1); });
    if (next) next.addEventListener('click', function () { activate(index + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        activate(parseInt(dot.dataset.ecbDot || '0', 10));
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.target && event.target.closest('[data-ecb-card-viewport]')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        activate(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        activate(index + 1);
      }
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (event) {
        if (!root.contains(event.target)) return;
        var selected = event.target.closest('[data-ecb-slide]');
        if (!selected) return;
        activate(parseInt(selected.dataset.ecbIndex || '0', 10));
      });
    }

    activate(index);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ecb]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
